import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout-component/auth-layout-component';
import { MainLayoutComponent } from './layout/main-layout-component/main-layout-component';
// import { AuthGuard } from '@core/guard/auth-guard';
import { NoAuthGuard } from '@core/guard/no-auth-guard';
import { PageNotFoundComponent } from './pages/page-not-found.component';
import { AuthLayoutPWAComponent } from './layout/auth-layout-pwa-component/auth-layout-pwa.component';
import { UrlMatcher, UrlSegment } from '@angular/router';
import { MaintenanceComponent } from './layout/maintenance-component/maintenance-component';
import { AuthGuard } from '@core/guard/auth-guard';
import { MaintenanceGuard } from '@core/guard/maintenance-guard';
import { AffiliationGuard } from '@core/guard/affiliation-guard';

export const routes: Routes = [
  {
    path: 'install-app',
    loadComponent: () =>
      import('./pwa/install-pwa.component').then((c) => c.InstallPwaComponent),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [MaintenanceGuard, AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      // {
      //   path: '',
      //   loadComponent: () =>
      //     import('./dashboard/home-main-component/home-main.component').then(
      //       (c) => c.HomeMainComponent
      //     ),
      // },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.routing').then(
            (m) => m.DASHBOARD_ROUTES
          ),
      },
      {
        path: 'simah',
        loadChildren: () =>
          import('./simah/simah.routing').then(
            (m) => m.SIMAH_ROUTES
          ),
      },
      {
        path: 'finance-request',
        loadChildren: () =>
          import('./finance/finance-request.routing').then(
            (m) => m.FINANCE_REQUEST_ROUTES
          ),
      },
      {
        path: 'user-profile',
        loadChildren: () =>
          import('./user-profile/user-profile.routing').then(
            (m) => m.USER_PROFILE_ROUTES
          ),
      },
      {
        path: 'finance-summary',
        loadChildren: () =>
          import('./finance-summary/finance-summary.routing').then(
            (m) => m.FINANCE_SUMMARY_ROUTES
          ),
      },
      {
        path: 'loan-repayment',
        loadChildren: () =>
          import('./finance-repayment/finance-repayment.routing').then(
            (m) => m.FINANCE_REPAYMENT_ROUTES
          ),
      },
      {
        path: 'loan-history',
        loadChildren: () =>
          import('./loan-history/loan-history.routing').then(
            (m) => m.LOAN_HISTORY_ROUTES
          ),
      },
      {
        path: 'finance-history',
        loadChildren: () =>
          import('./finance-history/finance-history.routing').then(
            (m) => m.FINANCE_HISTORY_ROUTES
          ),
      },
      {
        path: 'eligibility-checker',
        loadChildren: () =>
          import('./eligibility-checker/eligibility-checker.routing').then(
            (m) => m.ELIGIBILITY_CHECKER_ROUTES
          ),
      },
      {
        path: 'change-password',
        loadChildren: () =>
          import('./change-password/change-password.routing').then(
            (m) => m.CHANGE_PASSWORD_ROUTES
          ),
      },
      {
        path: 'deactivate-account',
        loadChildren: () =>
          import('./deactivate-account/deactivate-account.routing').then(
            (m) => m.DEACTIVATE_ACCOUNT_ROUTES
          ),
      },
      {
        path: 'contact-support',
        loadChildren: () =>
          import('./contact-support/contact-support.routing').then(
            (m) => m.CONTACT_SUPPORT_ROUTES
          ),
      },
      {
        path: 'lean',
        loadChildren: () =>
          import('./lean/lean.routing').then(
            (m) => m.LEAN_ROUTES
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./settings/settings.routing').then(
            (m) => m.SETtINGS_ROUTES
          ),
      },
      {
        path: 'other',
        loadChildren: () =>
          import('./other/other.routing').then(
            (m) => m.OTHERS_ROUTES
          ),
      }
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [MaintenanceGuard, NoAuthGuard],
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./auth/login-layout/login-layout.component').then((c) => c.LoginLayout),
      },
      {
        path: 'signup',
        loadComponent: () =>
          import('./auth/signup/signup.component').then(
            (c) => c.SignupComponent
          ),
      },
      {
        path: 'landing',
        loadComponent: () =>
          import('./auth/landing-decision/landing-decision.component').then(
            (c) => c.LandingDecisionComponent
          ),
      },
      {
        path: 'affiliation',
        loadComponent: () =>
          import('./auth/affiliation-layout/affiliation-layout').then(
            (c) => c.AffiliationLayoutComponent
          ),
        canActivate: [AffiliationGuard]
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./auth/forgot-password/forgot-password').then(
            (c) => c.ForgotPassword
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./auth/reset-password-layout/reset-password-layout').then(
            (c) => c.ResetPasswordLayout
          ),
      },
      {
        path: 'contact-support',
        loadComponent: () =>
          import('./auth/reset-password-layout/reset-password-layout').then(
            (c) => c.ResetPasswordLayout
          ),
      },
    ],
  },
  {
    path: "login-pwa",
    component: AuthLayoutPWAComponent,
    canActivate: [NoAuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pwa/auth/login-pwa.component/login-pwa.component')
            .then(c => c.LoginPwaComponent),
      },
      {
        path: 'login-otp',
        loadComponent: () =>
          import('./pwa/auth/login-OTP.component/login-OTP.component')
            .then(c => c.LoginOTPComponent),
      }
    ]
  },
  { path: 'maintenance', component: MaintenanceComponent, canActivate: [MaintenanceGuard] },
  { path: '404', component: PageNotFoundComponent },
  { path: '**', redirectTo: '404' },
];

